<template>
	<div style="background-color: #fff">
		<Hrader ref="hreders"></Hrader>
		<div>
			<div style="height: 70px"></div>
			<div class="assets-left">
				<img src="@/assets/byhs/Mask group(6).png" style="width: 100%; height: 552px" />

				<div class="account-content" v-if="1">
					<div class="captchaLogin">
						<div class="mobile" @click="clickJump(1)">
							<div class="mobile-title" :class="{ 'mobile-title1': ids == 1 }">手机验证码登录</div>
							<div class="bor-top" v-show="ids == 1"></div>
						</div>
						<div class="mobile" @click="clickJump(2)" style="margin-left: 50px">
							<div class="mobile-title" :class="{ 'mobile-title1': ids == 2 }">账号密码登录</div>
							<div class="bor-top" v-show="ids == 2"></div>
						</div>
					</div>

					<div v-if="ids == 1">
						<div class="mobile-bor">
							<img src="@/assets/Group 1268@2x.png" style="width: 11px; height: 16px; margin-left: 15px" />
							<input v-model="form.mobile" placeholder="手机号" class="input" />
						</div>
						<div class="mobile-bor" style="margin-top: 12px" v-if="!showNumber">
							<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
							<input v-model="form.code" placeholder="输入短信验证码" class="input" />
							<div class="mobile-flex" style="white-space: nowrap; color: #ff2f17" @click="SendCaptcha">发送验证码</div>
						</div>
						<div class="mobile-bor" style="margin-top: 12px" v-else>
							<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
							<input v-model="form.code" placeholder="输入短信验证码" class="input" />
							<div class="mobile-flex">{{ showNumber }}</div>
						</div>
					</div>

					<div v-if="ids == 2">
						<div class="mobile-bor">
							<img src="@/assets/contact_slices/Group 903@2x.png" style="width: 13px; height: 16px; margin-left: 15px" />
							<input v-model="form.mobile" placeholder="手机号码" class="input" />
						</div>
						<div class="mobile-bor" style="margin-top: 12px">
							<img src="@/assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
							<input type="password" v-model="form.password" placeholder="登录密码" class="input" />
						</div>
					</div>

					<div v-if="ids == 3">
						<div class="mobile-bor">
							<img src="@/assets/Group 1268@2x.png" style="width: 11px; height: 16px; margin-left: 15px" />
							<input v-model="form.mobile" placeholder="手机号" class="input" />
						</div>
						<div class="mobile-bor" style="margin-top: 12px" v-if="!showNumber">
							<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
							<input v-model="form.code" placeholder="输入短信验证码" class="input" />
							<div class="mobile-flex" style="white-space: nowrap; color: #ff2f17" @click="SendCaptcha">发送验证码</div>
						</div>
						<div class="mobile-bor" style="margin-top: 12px" v-else>
							<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
							<input v-model="form.code" placeholder="输入短信验证码" class="input" />
							<div class="mobile-flex">{{ showNumber }}</div>
						</div>
						<div class="mobile-bor" style="margin-top: 12px">
							<img src="@/assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
							<input type="password" placeholder="登录密码" class="input" />
						</div>
					</div>

					<div class="title-text" v-if="ids == 1">若手机号未注册，我们将自动为您注册</div>
					<div class="login" @click="clickLogin">登录</div>
					<div v-if="ids == 2" class="registerArkey" @click="clickJump(3)">忘记密码?</div>
					<div style="display: flex; justify-content: center; align-items: center">
						<el-checkbox v-model="checked" />
						<div class="have-read" style="margin-top: -2px">
							已阅读并同意
							<span style="color: #ff2f17" @click="protocolClick(1)">「百越回收用户服务协议」</span>
							和
							<span style="color: #ff2f17" @click="protocolClick(2)">「隐私政策」</span>
						</div>
					</div>
					<!-- 
					<div v-if="ids == 2" class="register" @click="register">注册</div>
					<div v-else class="register"></div> -->
				</div>

				<div class="account-content1" v-else>
					<div class="registered">
						注册
						<span style="color: #ff2f17">百越回收</span>
					</div>
					<div class="registered-text">财富不浪费 · 回收更省心</div>
					<div style="height: 8px"></div>
					<div class="mobile-bor">
						<img src="@/assets/Group 1268@2x.png" style="width: 11px; height: 16px; margin-left: 15px" />
						<input placeholder="手机号" class="input" />
					</div>
					<div class="mobile-bor" style="margin-top: 12px">
						<img src="@/assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
						<input placeholder="请输入密码" class="input" />
					</div>
					<div class="mobile-bor" style="margin-top: 12px">
						<img src="@/assets/Group 1272@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
						<input placeholder="请再次输入密码" class="input" />
					</div>
					<div class="mobile-bor" style="margin-top: 12px">
						<img src="@/assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
						<input placeholder="输入验证码" class="input" />
						<div class="mobile-flex">3n3d</div>
					</div>
					<div class="mobile-bor" style="margin-top: 12px">
						<img src="@/assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
						<input placeholder="输入短信验证码" class="input" />
						<div class="mobile-flex">发送验证码</div>
					</div>
					<div class="mobile-bor1" style="margin-top: 12px">
						<div class="flex-slice">
							<img src="@/assets/recycling_slices/Slice 14@2x(1).png" style="width: 12px; height: 12px" />
						</div>
						<div class="have-read">
							已阅读并同意
							<span style="color: #ff2f17" @click="protocolClick(1)">「百越回收用户服务协议」</span>
							和
							<span style="color: #ff2f17" @click="protocolClick(2)">「隐私政策」</span>
						</div>
					</div>
					<div class="login" style="margin-top: 17px">登录</div>
					<div class="flex-pws">
						<span style="color: #aaaaaa">已有账号，</span>
						<span>请登录</span>
					</div>
				</div>
			</div>
			<MoreWidth></MoreWidth>
			<el-dialog title="服务协议" v-model="dialogVisible1" width="700" :before-close="handleClose">
				<div style="height: 500px; overflow: hidden; overflow-y: auto; margin-top: 20px">
					<div v-html="text"></div>
				</div>
				<template #footer></template>
			</el-dialog>

			<el-dialog title="隐私协议" v-model="dialogVisible2" width="700" :before-close="handleClose">
				<div style="height: 500px; overflow: hidden; overflow-y: auto; margin-top: 20px">
					<div v-html="textTile"></div>
				</div>
				<template #footer></template>
			</el-dialog>
		</div>
		<Tabr></Tabr>
		<Verify mode="pop" @success="handleSuccess" :captchaType="captchaType" :imgSize="{ width: '400px', height: '200px' }" ref="verify"></Verify>
	</div>
</template>

<script setup>
import Verify from '@/components/verifition/Verify';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Hrader from '@/components/header.vue';
import MoreWidth from '@/components/moreWidth.vue';
import Tabr from '@/components/tabrButton.vue';
import { sendSmsCode, smsLogin, memberUserGet, configUserProtocolDAta, authLogin } from '@/utils/api.js';
import { ElMessage } from 'element-plus';
const dialogVisible1 = ref(false);
const dialogVisible2 = ref(false);
let router = useRouter();
let form = ref({});
let text = ref('');
let title = ref('服务协议');
let idsTar = ref(1);
let textTile = ref('');
let checked = ref(false);
let ids = ref(1);
let showNumber = ref(0);
const register = () => {
	console.log(111);
};
onMounted(() => {
	window.scrollTo(0, 0);
	infoScrotop();
});

const infoScrotop = () => {
	configUserProtocolDAta('user_protocol_html').then((res) => {
		console.log(res.data.value);
		text.value = res.data.value;
	});
	configUserProtocolDAta('privacy_protocol_html').then((res) => {
		console.log(res.data.value);
		textTile.value = res.data.value;
	});
};

const verify = ref(null);
const captchaType = ref('blockPuzzle');

const SendCaptcha = () => {
	if (showNumber.value != 0) return false;
	const phoneRegex = /^1[3-9]\d{9}$/;
	if (!form.value.mobile) {
		ElMessage({
			message: '手机号不能为空',
			type: 'error'
		});
		return false;
	}
	if (!phoneRegex.test(form.value.mobile)) {
		ElMessage({
			message: '手机号格式正确',
			type: 'error'
		});
		return false;
	}
	verify.value.show();
};

const sendSmsCodeClick = async () => {
	const data = await sendSmsCode({
		mobile: form.value.mobile,
		scene: 1
	});
	if (data.data) {
		showNumber.value = 60;
		infoNumber();
	} else {
		ElMessage({
			message: data.msg,
			type: 'error'
		});
	}
};

const handleSuccess = (res) => {
	if (ids.value == 2) {
		authLoginClick();
		return;
	}
	sendSmsCodeClick();
};

const authLoginClick = async () => {
	let res = await authLogin({
		fromProxyId: '',
		mobile: form.value.mobile,
		password: form.value.password
	});
	if (res.msg) {
		ElMessage({
			message: res.msg,
			type: 'error'
		});
	} else {
		infoatin();
		localStorage.setItem('londEssage', JSON.stringify(res.data));
	}
};

const clickLogin = async () => {
	const phoneRegex = /^1[3-9]\d{9}$/;
	if (!checked.value) {
		ElMessage({
			message: '请勾选隐私政策',
			type: 'error'
		});
		return false;
	}
	if (!form.value.mobile) {
		ElMessage({
			message: '手机号不能为空',
			type: 'error'
		});
		return false;
	}
	if (!phoneRegex.test(form.value.mobile)) {
		ElMessage({
			message: '手机号格式正确',
			type: 'error'
		});
		return false;
	}
	if (ids.value == 2) {
		verify.value.show();
		return;
	}
	if (!form.value.code) {
		ElMessage({
			message: '请输入验证码',
			type: 'error'
		});
		return false;
	}
	const res = await smsLogin({
		fromProxyId: '',
		mobile: form.value.mobile,
		code: form.value.code,
		bdParam: localStorage.getItem('bd_vid'),
	});
	if (res.msg) {
		ElMessage({
			message: res.msg,
			type: 'error'
		});
	} else {
		infoatin();
		localStorage.setItem('londEssage', JSON.stringify(res.data));
	}
};
const infoatin = async () => {
	let res = await memberUserGet();
	localStorage.setItem('information', JSON.stringify(res.data));
	ElMessage({
		message: '登陆成功',
		type: 'success'
	});
	router.push({ path: '/' });
	// window.history.go(-1);
};
const infoNumber = () => {
	setTimeout(() => {
		if (showNumber.value) {
			showNumber.value = showNumber.value - 1;
			infoNumber();
		}
	}, 1000);
};
const protocolClick = (item) => {
	if (item == 1) {
		dialogVisible1.value = true;
	} else {
		dialogVisible2.value = true;
	}
};
const clickJump = (index) => {
	if (index == 3) {
		router.push({
			path: '/recovery'
		});
	}
	ids.value = index;
};
</script>

<style lang="scss" scoped>
.assets-left {
	position: relative;
	width: 100%;
	z-index: 1;
	height: 552px;
}
.account-content {
	width: 390px;
	// height: 329px;
	padding-bottom: 15px;
	background: #ffffff;
	box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
	border-radius: 4px 4px 4px 4px;
	position: absolute;
	top: 140px;
	right: 258px;
}
.captchaLogin {
	display: flex;
	align-items: flex-start;
	justify-content: center;
	margin-top: 40px;
}

.captchaLogin:hover {
	cursor: pointer;
}

.mobile-title1 {
	color: #ff2f17;
}
.mobile {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.bor-top {
	width: 26px;
	height: 4px;
	background: #ff2f17;
	border-radius: 6px 6px 6px 6px;
	margin-top: 4px;
}

.mobile-bor {
	width: 320px;
	height: 42px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	margin: auto;
	margin-top: 22px;
}
.mobile-bor1 {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: auto;
	margin-top: 40px;
}

.input {
	border: none;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #000;
	font-style: normal;
	text-transform: none;
	margin-left: 10px;
}
.input::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}
input:focus {
	outline: none;
	border: none;
}
.login {
	width: 320px;
	height: 42px;
	background: #ff2f17;
	border-radius: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin: auto;
	margin-top: 12px;
}

.login:hover {
	cursor: pointer;
}

.register {
	text-align: center;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	margin-top: 10px;
	color: blue;
}

.register:hover {
	cursor: pointer;
}

.account-content1 {
	width: 390px;
	background: #ffffff;
	border-radius: 7px;
	position: relative;
	padding-bottom: 10px;
	position: absolute;
	top: 18px;
	right: 258px;
	position: absolute;
}

.registered {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 57px;
	margin-top: 30px;
}
.registered-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 13px;
	color: #333333;
	letter-spacing: 3px;
	font-style: normal;
	text-transform: none;
	margin-left: 57px;
	margin-top: 7px;
}
.have-read {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	padding-left: 7px;
}
.have-read:hover {
	cursor: pointer;
}

.flex-pws {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ff2f17;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.flex-pws:hover {
	cursor: pointer;
}

.mobile-flex {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ff2f17;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: auto;
	margin-right: 20px;
}
.mobile-flex:hover {
	cursor: pointer;
}

.title-text {
	text-align: center;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aeaeac;
	text-align: left;
	font-style: normal;
	text-align: center;
	margin-top: 10px;
	text-transform: none;
}

.registerArkey {
	width: 350px;
	text-align: right;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	margin-top: 3px;
	color: #000;
}
.registerArkey:hover {
	cursor: pointer;
}
</style>
